import { Component, Output, EventEmitter, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GameState } from '../../interfaces/game.interface';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-q4-feedback-page',
  templateUrl: './q4-feedback-page.component.html',
  styleUrls: ['./q4-feedback-page.component.scss']
})
export class Q4FeedbackPageComponent implements OnInit, AfterViewInit {
  @Output() continueClick = new EventEmitter<void>();
  @ViewChild('swiperQ4Feedback') swiper!: ElementRef<any>;

  currentSlide: number = 0;
  game_state: GameState | null = null;

  constructor(private dataService: DataService) {}

  onContinueClick(): void {
    this.continueClick.emit();
  }

  ngOnInit(): void {
    this.game_state = this.dataService.getGameStateSnapshot();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initializeSwiper(), 100);
  }

  getQComparisonData() {
    if (this.game_state) {
      return {
        q2: this.game_state.kpi["q2_end"],
        q3: this.game_state.kpi["q3_end"],
        q4: this.game_state.kpi["q4_end"]
      }
    }
    return null;
  }

  initializeSwiper() {
    const swiperParams = {
      updateOnWindowResize: true,
      pagination: true,
    };

    Object.assign(this.swiper.nativeElement, swiperParams);
    this.swiper.nativeElement.initialize();

    this.swiper.nativeElement.addEventListener('swiperslidechange', (event) => {
      this.currentSlide = this.swiper.nativeElement.swiper.activeIndex;
    });
  }

  prevShop() {
    this.swiper.nativeElement.swiper.slidePrev();
    this.currentSlide = this.swiper.nativeElement.swiper.activeIndex;
  }

  nextShop() {
    this.swiper.nativeElement.swiper.slideNext();
    this.currentSlide = this.swiper.nativeElement.swiper.activeIndex;
  }
}
